import { Col, Form, Row } from 'react-bootstrap';

const Step3 = ({ formData, setFormData }) => {
  return (
    <div className="card p-4">
      <h5 className="card-title mb-3">Step 3: Contact Info</h5>
      <Form>
        {/* Contact Person Section */}
        <Row className="mb-3">
          <Col md={3}>
            <Form.Label>Last Name *</Form.Label>
            <Form.Control
              type="text"
              value={formData.contactLastName || ''}
              onChange={(e) => setFormData({ ...formData, contactLastName: e.target.value })}
            />
          </Col>
          <Col md={3}>
            <Form.Label>First Name *</Form.Label>
            <Form.Control
              type="text"
              value={formData.contactFirstName || ''}
              onChange={(e) => setFormData({ ...formData, contactFirstName: e.target.value })}
            />
          </Col>
          <Col md={3}>
            <Form.Label>Middle Name</Form.Label>
            <Form.Control
              type="text"
              value={formData.contactMiddleName || ''}
              onChange={(e) => setFormData({ ...formData, contactMiddleName: e.target.value })}
            />
          </Col>
          <Col md={3}>
            <Form.Label>Suffix</Form.Label>
            <Form.Control
              type="text"
              value={formData.contactSuffix || ''}
              onChange={(e) => setFormData({ ...formData, contactSuffix: e.target.value })}
            />
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={3}>
            <Form.Label>Relationship</Form.Label>
            <Form.Select
              value={formData.contactRelationship || ''}
              onChange={(e) => setFormData({ ...formData, contactRelationship: e.target.value })}
            >
              <option value="">Select Relationship</option>
              <option value="Spouse">Spouse</option>
              <option value="Parent">Parent</option>
              <option value="Sibling">Sibling</option>
              <option value="Relative">Relative</option>
              <option value="Friend">Friend</option>
            </Form.Select>
          </Col>
        </Row>

        <hr />

        {/* Contact Information Section */}
        <Row className="mb-3">
          <Col md={4}>
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              value={formData.contactEmail || ''}
              onChange={(e) => setFormData({ ...formData, contactEmail: e.target.value })}
            />
          </Col>
          <Col md={4}>
            <Form.Label>Tel No</Form.Label>
            <Form.Control
              type="text"
              value={formData.tel1 || ''}
              onChange={(e) => setFormData({ ...formData, tel1: e.target.value })}
            />
          </Col>
          <Col md={4}>
            <Form.Label>Tel No 2</Form.Label>
            <Form.Control
              type="text"
              value={formData.tel2 || ''}
              onChange={(e) => setFormData({ ...formData, tel2: e.target.value })}
            />
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <Form.Label>Mobile No *</Form.Label>
            <Form.Control
              type="text"
              value={formData.mobile1 || ''}
              onChange={(e) => setFormData({ ...formData, mobile1: e.target.value })}
            />
          </Col>
          <Col md={4}>
            <Form.Label>Mobile No 2</Form.Label>
            <Form.Control
              type="text"
              value={formData.mobile2 || ''}
              onChange={(e) => setFormData({ ...formData, mobile2: e.target.value })}
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Step3;
